import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import reportReducer from './reducers/reportReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  report: reportReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
